
import React from "react";
import { MapPin, Phone, Mail, Globe } from "lucide-react";
import { Site } from "@/services/types";

interface SiteCardContactProps {
  site: Site;
  isMiniSite?: boolean;
}

const SiteCardContact = ({ site, isMiniSite = false }: SiteCardContactProps) => {
  return (
    <>
      {!isMiniSite && (
        <div className="flex items-start">
          <MapPin className="h-5 w-5 text-fabre-green mr-3 mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-gray-700">{site.address}</p>
            <p className="text-gray-700">{site.postalCode} {site.city}</p>
          </div>
        </div>
      )}
      
      <div className="flex items-start">
        <Phone className="h-5 w-5 text-fabre-green mr-3 mt-0.5 flex-shrink-0" />
        <a 
          href="tel:0532092185"
          className="text-fabre-green hover:underline font-medium"
        >
          05 32 09 21 85
        </a>
      </div>
      
      {site.email && (
        <div className="flex items-start">
          <Mail className="h-5 w-5 text-fabre-green mr-3 mt-0.5 flex-shrink-0" />
          <a 
            href={`mailto:${site.email}`}
            className="text-fabre-green hover:underline font-medium"
          >
            {site.email}
          </a>
        </div>
      )}

      {site.websiteUrl && (
        <div className="flex items-start">
          <Globe className="h-5 w-5 text-fabre-green mr-3 mt-0.5 flex-shrink-0" />
          <a 
            href={site.websiteUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-fabre-green hover:underline font-medium"
          >
            Visiter le site web
          </a>
        </div>
      )}
    </>
  );
};

export default SiteCardContact;
